import { IpisFormElement } from "@eljouren/domain";
import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistImageGroupBuilder from "./ChecklistImageGroupBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
  question: IpisFormElement.ImageGroupType;
}

const ChecklistImageGroupEditor = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistImageGroupBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.editElement({ id: props.question.id, newValues: values });
        props.closeForm();
      }}
      defaultValues={props.question}
    />
  );
};

export default ChecklistImageGroupEditor;
